@switch (mode()) {
  @case ('pending') {
    <div
      class="ai-pending-border flex flex-col w-full rounded-lg pl-3 pr-1 py-2">
      <div class="flex items-center gap-2.5 text-sm text-gray-600">
        <mat-icon
          svgIcon="wand-magic-outline"
          class="w-4! h-4! text-primary-700! shrink-0"></mat-icon>

        @if (submittedPatientName(); as name) {
          <span
            class="inline-flex items-center gap-1 rounded-md bg-primary-100 px-2 py-0.5 text-sm font-medium text-primary-800 shrink-0">
            <span
              class="flex items-center justify-center rounded-full bg-primary-800 w-3 h-3 shrink-0">
              <mat-icon
                svgIcon="user-circle-fixed"
                class="w-3! h-3! text-white!"></mat-icon>
            </span>
            {{ name }}
          </span>
        }

        <icaredx-spinner size="xs" color="secondary" />
        <span class="truncate text-primary-800">
          AI is preparing an answer. Please wait for a while.
        </span>

        <span class="text-gray-300">|</span>
        <button
          type="button"
          (click)="toggleShowPrompt()"
          class="font-medium text-primary-800 hover:text-primary-900 cursor-pointer shrink-0">
          {{ showPrompt() ? 'Hide prompt' : 'Show prompt' }}
        </button>
      </div>

      @if (showPrompt()) {
        <p class="mt-2 text-sm text-gray-500 whitespace-pre-wrap">
          {{ lastQuestion() }}
        </p>
      }
    </div>
  }

  @case ('completed') {
    <div
      class="inline-flex items-center gap-2.5 rounded-lg border border-primary-700 bg-linear-to-b from-[#fafcff] to-[#f5f9ff] pl-3 pr-1 py-2">
      <mat-icon
        svgIcon="check"
        class="w-4! h-4! text-primary-700! shrink-0"></mat-icon>

      @if (submittedPatientName(); as name) {
        <span
          class="inline-flex items-center gap-1 rounded-md bg-primary-100 px-2 py-0.5 text-sm font-medium text-primary-800 shrink-0">
          <span
            class="flex items-center justify-center rounded-full bg-primary-800 w-3 h-3 shrink-0">
            <mat-icon
              svgIcon="user-circle-fixed"
              class="w-3! h-3! text-white!"></mat-icon>
          </span>
          {{ name }}
        </span>
      }

      <button
        type="button"
        (click)="viewResult()"
        class="flex items-center gap-1.5 px-3 py-2 text-xs font-medium rounded-lg hover:bg-primary-800 bg-primary-700 text-white cursor-pointer transition-colors shrink-0">
        <mat-icon svgIcon="eye-outline" class="w-4! h-4!"></mat-icon>
        View
      </button>

      <button
        type="button"
        (click)="startOver()"
        class="flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-white rounded-lg bg-primary-700 hover:bg-primary-800 cursor-pointer transition-colors shrink-0">
        <mat-icon svgIcon="refresh" class="w-3! h-3!"></mat-icon>
        Start over
      </button>
    </div>
  }

  @default {
    @if (isMultiline()) {
      <div class="h-10 w-full pointer-events-none invisible"></div>
    }
    <div
      class="flex items-start gap-2.5 w-full rounded-lg border border-primary-200 bg-linear-to-b from-[#fafcff] to-[#f5f9ff] px-3 py-1.5 transition-colors"
      [class]="
        isMultiline() ? 'absolute top-0 left-0 right-0 z-50 shadow-lg' : ''
      ">
      <div class="flex flex-1 items-start gap-1 min-w-0">
        <div class="w-6.25 h-6.25 flex items-center justify-center">
          <mat-icon
            svgIcon="wand-magic-outline"
            class="w-4! h-4! text-primary-700! shrink-0"></mat-icon>
        </div>

        @if (patientName(); as name) {
          <span
            class="inline-flex items-center gap-1 rounded-md bg-primary-100 px-2 py-0.5 text-sm font-medium text-primary-800 shrink-0">
            <span
              class="flex items-center justify-center rounded-full bg-primary-800 w-3 h-3 shrink-0">
              <mat-icon
                svgIcon="user-circle-fixed"
                class="w-3! h-3! text-white!"></mat-icon>
            </span>
            {{ name }}
            <button
              type="button"
              (click)="removePatientChip()"
              class="text-primary-600 hover:text-primary-800 cursor-pointer flex items-center">
              <mat-icon
                svgIcon="x-outline"
                class="w-3! h-3! text-primary-800!"></mat-icon>
              <span class="sr-only">Remove patient from question</span>
            </button>
          </span>
        }

        <div class="w-px self-stretch my-1 bg-gray-500 shrink-0"></div>
        <textarea
          #textarea
          rows="1"
          [value]="query()"
          [placeholder]="placeholder()"
          (input)="onInput($event)"
          (keydown.enter)="onEnter($event)"
          class="border-0 flex-1 min-w-0 py-0.5 px-2 resize-none overflow-hidden bg-transparent text-sm font-normal text-gray-900 placeholder-gray-400 shadow-none outline-none focus:border-0 focus:ring-0 focus:shadow-none focus:outline-none leading-normal"></textarea>
      </div>

      @if (query()) {
        <button
          type="button"
          (click)="clearQuery()"
          class="w-6.25 h-6.25 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer shrink-0">
          <mat-icon svgIcon="x-outline" class="w-4! h-4!"></mat-icon>
          <span class="sr-only">Clear question</span>
        </button>
      }

      <button
        type="button"
        (click)="submit()"
        [disabled]="!canSubmit()"
        class="flex items-center justify-center bg-primary-700 w-6.25 h-6.25 rounded-lg shrink-0 transition-colors"
        [class]="
          canSubmit()
            ? 'hover:bg-primary-800 cursor-pointer'
            : 'cursor-not-allowed'
        ">
        <mat-icon
          svgIcon="send-horizontal"
          class="w-3! h-3! text-white!"></mat-icon>
        <span class="sr-only">Ask AI</span>
      </button>
    </div>
  }
}
